export default __webpack_public_path__ + "static/red-a20282b248257aa32201202852fc32db.png";